<nz-layout class="app-layout">
	<nz-sider class="menu-sidebar" nzCollapsible nzWidth="256px" nzBreakpoint="md" [(nzCollapsed)]="isCollapsed" [nzTrigger]="null">
		<div class="sidebar-logo">
			<a href="/">
				<img *ngIf="!isCollapsed" src="assets/images/PandaHorizontalLogo.575d1c28.png" style="height: 3em;" />
				<img *ngIf="isCollapsed" src="assets/images/PandaHorizontalLogo.575d1c28.png" style="height: 3.6em;" />
			</a>
		</div>
		<div class="side-menu">
			<ul nz-menu nzTheme="dark" nzMode="inline" [nzInlineCollapsed]="isCollapsed">
				<li nz-submenu nzTitle="Member Records" nzIcon="usergroup-add" *hasPermission="['MemberAdd','MembersBulkImport','MemberSearch']">
					<ul>
						<a nz-menu-item nzMatchRouter routerLink="/member/new" *hasPermission="['MemberAdd']">
							Add Member
						</a>
						<a nz-menu-item nzMatchRouter routerLink="/member/bulk/list" *hasPermission="['MembersBulkImport']">
							Bulk Upload
						</a>
						<a nz-menu-item nzMatchRouter routerLink="/member/list" *hasPermission="['MemberSearch']">
							Search Member
						</a>
					</ul>
				</li>
				<li nz-submenu nzTitle="Claims" nzIcon="retweet" *hasPermission="['Ticket','TicketAdmin']">
					<ul>
						<a nz-menu-item nzMatchRouter routerLink="/ticket/Claim/member-search" *hasPermission="['Ticket','TicketAdmin']">
							New Claim
						</a>
						<a nz-menu-item nzMatchRouter routerLink="/ticket/Claim/list" *hasPermission="['Ticket','TicketAdmin']">
							My Claims
						</a>
						<a nz-menu-item nzMatchRouter routerLink="/ticket/Claim/dashboard" *hasPermission="['Ticket','TicketAdmin']">
							Claims workflows
						</a>
					</ul>
				</li>
				<li nz-submenu nzTitle="Complaints" nzIcon="file-exclamation" *hasPermission="['Ticket','TicketAdmin']">
					<ul>
						<a nz-menu-item nzMatchRouter routerLink="/ticket/Complaint/member-search" *hasPermission="['Ticket','TicketAdmin']">
							New Complaint
						</a>
						<a nz-menu-item nzMatchRouter routerLink="/ticket/Complaint/list" *hasPermission="['Ticket','TicketAdmin']">
							My Complaints
						</a>
						<a nz-menu-item nzMatchRouter routerLink="/ticket/Complaint/dashboard" *hasPermission="['Ticket','TicketAdmin']">
							Complaints workflows
						</a>
					</ul>
				</li>
				<li nz-submenu nzTitle="Reporting" nzIcon="bar-chart">
					<ul>
						<a nz-menu-item nzMatchRouter routerLink="/ticket/report/list" *hasPermission="['TicketReportList', 'TicketAdmin']">
							Claim Reports
						</a>
					</ul>
				</li>
				<a nz-menu-item nzMatchRouter routerLink="/dashboard/total">
					<fa-icon [icon]="faHome" class="me-1"></fa-icon>
					<span *ngIf="!isCollapsed">Analytics</span>
				</a>
				<li nz-submenu nzTitle="Communication" nzIcon="mail" *hasPermission="['CommunicationSend','CommunicationScheduledAutomated', 'CommunicationLog']">
					<ul>
						<a nz-menu-item nzMatchRouter routerLink="/communication/send" *hasPermission="['CommunicationSend']">
							Send Communication
						</a>
						<a nz-menu-item nzMatchRouter routerLink="/communication/scheduled-automated" *hasPermission="['CommunicationScheduledAutomated']">
							Scheduled & Automated
						</a>
						<a nz-menu-item nzMatchRouter routerLink="/communication/log" *hasPermission="['CommunicationLog']">
							Communication Log
						</a>
					</ul>
				</li>
				<li nz-submenu nzTitle="Entity" nzIcon="appstore-add" *hasPermission="['AgentList', 'AgentAdd', 'EntityList', 'EntityAdd']">
					<ul>
						<a nz-menu-item nzMatchRouter routerLink="/agent/admin/list" *hasPermission="['AgentList','AgentAdd']">
							Agent Admin
						</a>
						<a nz-menu-item nzMatchRouter routerLink="/agent/fao/list" *hasPermission="['AgentList','AgentAdd']">
							Agent FAO
						</a>
						<a nz-menu-item nzMatchRouter routerLink="/agent/underwriter/list" *hasPermission="['AgentList','AgentAdd']">
							Agent Underwriters
						</a>

						<a nz-menu-item nzMatchRouter routerLink="/category/list" *hasPermission="['EntityList','EntityAdd']">
							Categories
						</a>
						<a nz-menu-item nzMatchRouter routerLink="/employer/list" *hasPermission="['EntityList','EntityAdd']">
							Employers
						</a>
					</ul>
				</li>
				<li nz-submenu nzTitle="Configuration" nzIcon="setting" *hasPermission="['DynamicPropertyView','WorkflowView','WorkflowAdd','RoleList','PermissionManage','WorkflowManageRoles']">
					<ul>
						<a nz-menu-item nzMatchRouter routerLink="/dynamic/list" *hasPermission="['DynamicPropertyView']">
							Dynamic Properties
						</a>
						<a nz-menu-item nzMatchRouter routerLink="/workflow/list" *hasPermission="['WorkflowView','WorkflowAdd']">
							Workflows
						</a>
						<a nz-menu-item nzMatchRouter routerLink="/workflow_role/list" *hasPermission="['WorkflowManageRoles']">
							Ticket Roles
						</a>
						<a nz-menu-item nzMatchRouter routerLink="/role/list" *hasPermission="['RoleList']">
							App Roles
						</a>
						<a nz-menu-item nzMatchRouter routerLink="/permissions" *hasPermission="['PermissionManage']">
							App Permissions
						</a>
					</ul>
				</li>
				<li class="ant-menu-item no-highlight-item mt-3" *ngIf="!isCollapsed">
					<nz-select [(ngModel)]="theme" (ngModelChange)="onThemeChange($event)" style="width: 100%;">
						<nz-option nzValue="default" nzLabel="Default"></nz-option>
						<nz-option nzValue="compact" nzLabel="Compact"></nz-option>
					</nz-select>
				</li>
			</ul>
		</div>
	</nz-sider>
	<nz-layout class="content-layout">
		<nz-header>
			<div class="app-header">
				<span class="header-trigger" (click)="isCollapsed = !isCollapsed">
					<span class="trigger" nz-icon [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"></span>
				</span>
				<app-hierarchy-input  *ngIf="hierarchy" (onChange)="changeHierarchy($event)"></app-hierarchy-input>
				<div class="float-end me-3">
					<div ngbDropdown>
						<div ngbDropdownToggle class="align-items-center btn btn-sm me-2" id="profileDropdown">
							<span class="me-2">{{username}}</span>
							<img src="https://w7.pngwing.com/pngs/751/863/png-transparent-user-customer-account-customers-person-filled-profile-ios-tab-bar-icon-thumbnail.png" alt="User" class="rounded-circle" width="32" height="32" />
						</div>
						<div ngbDropdownMenu aria-labelledby="profileDropdown">
							<a class="dropdown-item" [routerLink]="['/agent','self']">Profile</a>
							<div class="dropdown-divider"></div>
							<button class="dropdown-item" (click)="logout()">Logout</button>
						</div>
					</div>
				</div>
			</div>
		</nz-header>
		<nz-content>
			<div class="inner-content">
				<router-outlet *ngIf="hierarchy"></router-outlet>
				<div class="fixed-widgets" *ngIf="chatVisible == false">
					<nz-float-button [nzIcon]="icon" nzType="primary" (click)="openChat()">
						<ng-template #icon >
							<img
								src="assets/images/Panda%20-%20Icon%20(Dark%20Background).png"
								alt="Panda"
								style="width: 20px; height: 20px"
							/>
						</ng-template>
					</nz-float-button>
				</div>

				<nz-drawer
					[nzVisible]="chatVisible"
					nzPlacement="right"
					nzTitle="POH AI Assistant"
					(nzOnClose)="chatVisible = false"
					[nzWidth]="600">
					<app-ai-chat-widget *nzDrawerContent>

					</app-ai-chat-widget>
				</nz-drawer>
			</div>
		</nz-content>
	</nz-layout>
</nz-layout>
